import _ from "lodash";
import { memo, useCallback, useEffect } from "react";
import { MetaDataSelector } from "../../../components/MetadataSelector";
import { useAppData } from "../../../hooks";
import { useTagData } from "../../../hooks/useTagData";

type SuggestionMetadataSelectorProps = {
  appId: string;
};

export const SuggestionMetadataSelector = memo(({ appId }: SuggestionMetadataSelectorProps) => {
  const [metadataTags, setMetadataTags] = useAppData<Array<string>>(appId, "metadataTags");
  const [filters, setFilters] = useAppData<Record<string, any>>(appId, "filters", {});
  const [workspaceId] = useAppData<string>(appId, "workspaceId");
  const { workspaceVisibleTags, isLoading: isLoadingTags } = useTagData(undefined, {
    workspaceId: workspaceId,
    includeAll: false,
  });

  const { workspaceVisibleTagCategories } = useTagData(metadataTags ?? [], {
    workspaceId,
    includeAll: false,
  });

  useEffect(() => {
    const selectedTagsFilter: Record<string, string[]> = _.pickBy(
      _.mapValues(workspaceVisibleTagCategories, (tags) => _.map(tags, "tagId")),
      (tagIds) => tagIds.length > 0
    );
    setFilters({
      keywords: filters.keywords ?? "",
      ...selectedTagsFilter,
    });
  }, [metadataTags]);

  const onSelectedMetadataTagsChange = useCallback(
    (tags: Array<string>) => {
      setMetadataTags(tags);
    },
    [setMetadataTags]
  );

  return (
    <MetaDataSelector
      isLoading={isLoadingTags}
      tags={workspaceVisibleTags}
      selected={metadataTags}
      onSelectedTagsChange={onSelectedMetadataTagsChange}
      appId={appId}
    />
  );
});
